import React, { Component, useState } from 'react';
import ForgotPasswordView from './ForgotPasswordView'
import crmservices from '../../wsclient/crmservices';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import { navigate } from '../../../portal.router.config';
function ForgotPasswordController(props) {

    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});

    const onForgotPassword = async(values) =>{
        onShowLoading(true);
        //console.log('onForgotPassword values===', values)
        if(values&&values.username)    
            try {
                var result = await crmservices.contacts.forgotPassword(values.username);
                //console.log("onForgotPassword result:",result);
                if(result.code=='OK'){
                    showMessage(true,t('FORGOT_PASSWORD_SUCCESS'));
                }else if(result.code=='FORGOT_EMAIL_NOT_FOUND_EXCEPTION'){
                    showMessage(true,t('FORGOT_EMAIL_NOT_FOUND_EXCEPTION'));
                } else if(result.code=='TOO_MANY_REQUESTS'){
                    showMessage(t('ERROR'), t('TOO_MANY_REQUESTS'));
                } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                    showMessage(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
                }else{
                    showMessage(true,t('FORGOT_PASSWORD_FAIL'));
                }
            } catch (error) {
                console.log("on forgot password exception:", error);
                showMessage(true,t('EXCEPTION_PROCESS'));
            }
        onShowLoading(false);
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }
    const closeMessage = () =>{
        setMessage({
            show: false,
            content: null
        })
        navigate('/login');
    }
    return (
        <div>
            <ForgotPasswordView 
                onForgotPassword={onForgotPassword}/>
            <Loading showLoading={showLoading} />
            {message && <ModalAlert
                open={message.show}
                onClose={closeMessage}
                message={message.content}/>}
        </div>
    );
}

export default ForgotPasswordController;